import { useTheme } from "styled-components";
import {
  StyledLoginLogo,
  StyledLoginWidthConstraint,
} from "../login/LoginPageStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../styles/LayoutStyles";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../styles/CardStyles";
import { useLanguageContext } from "../../context/LanguageContext";
import LanguageSelect from "../../components/select/custom/language/LanguageSelect";
import ThemeSelect from "../../components/select/custom/theme/ThemeSelect";
import { StyledButton } from "../../styles/ButtonStyles";
import HiddenLoader from "../../components/loader/HiddenLoader/HiddenLoader";
import PasswordResetInput from "./input/PasswordResetInput";

function PasswordResetPageView({
  passwordResetData,
  setPasswordResetData,
  onSubmit,
  submitError,
}) {
  const { translate } = useLanguageContext();
  const theme = useTheme();

  return (
    <StyledLoginWidthConstraint>
      <StyledLoginLogo src={`/assets/images/${theme.logo}`} alt="EVA Logo" />

      <StyledCard>
        <StyledCardHeader>
          <StyledFlexRow style={{ alignItems: "center" }}>
            <StyledFlexItem>
              <h2>
                {translate("eva.main.auth.password_reset.confirm.header")}
              </h2>
            </StyledFlexItem>

            <LanguageSelect />

            <ThemeSelect />
          </StyledFlexRow>
        </StyledCardHeader>

        <StyledCardBody>
          <StyledFlexColumn
            style={{ gap: theme.spacing.large, alignItems: "flex-start" }}
          >
            <PasswordResetInput
              data={passwordResetData}
              setData={setPasswordResetData}
              submitError={submitError}
              style={{ width: "100%" }}
            />

            <HiddenLoader
              groups={["reset_password"]}
              containerStyle={{ display: "inline-block" }}
            >
              <StyledButton onClick={onSubmit}>
                {translate("eva.main.general.save")}
              </StyledButton>
            </HiddenLoader>
          </StyledFlexColumn>
        </StyledCardBody>
      </StyledCard>
    </StyledLoginWidthConstraint>
  );
}

export default PasswordResetPageView;
